export default __webpack_public_path__ + "static/media/link.73f0fac3.svg";